import { createBreakpoints } from '@chakra-ui/theme-tools';
import { breakpoint } from '@core-ds/primitives';

export default createBreakpoints(breakpoint);
